const format = /^\d{2}:\d{2}:\d{2}(.\d+)?$/

function pad(num, size) {
    var s = "000" + num;
    return s.substr(s.length-size);
}

export default class LocalTime{

    constructor(hh, mm, ss) {

        /** @type {string} format: 12:10:10.0038644*/
        this.value = null;

        if(hh !== undefined && mm !== undefined && ss !== undefined){
            this.set(hh, mm, ss);
        }
    }

    _getPos(start, end){
        if(this.value === null){
            return null;
        }
        if(!this.value.match(format)){
            return null;
        }
        return Number(this.value.substring(start,end));

    }

    getHours(){
        return this._getPos(0, 2);
    }

    getMinutes(){
        return this._getPos(3, 5);
    }

    getSeconds(){
        return this._getPos(6, this.value.length);
    }

    toJSON(){
        return this.value;
    }

    fromMoment(momentDate){
        this.set(momentDate.hours(), momentDate.minutes(), momentDate.seconds() + (momentDate.milliseconds() / 1000));
    }

    set(hh, mm, ss){
        if(ss >= 60){
            ss = 59.9999;
        } else if(ss < 0){
            ss = 0;
        }
        let formattedSeconds = "" + ss;
        if(ss < 10){
            formattedSeconds = "0" + formattedSeconds;
        }

        this.value = pad(hh, 2) + ":" + pad(mm, 2) + ":" + formattedSeconds;
    }

    toString(format){
        if(this.value){
            return moment(this.value, "HH:mm:ss").format(format);
        }
        else{
            return '';
        }
    }

}